import { render, staticRenderFns } from "./DataBody2.vue?vue&type=template&id=15cee08e&"
import script from "./DataBody2.vue?vue&type=script&lang=js&"
export * from "./DataBody2.vue?vue&type=script&lang=js&"
import style0 from "./DataBody2.vue?vue&type=style&index=0&id=15cee08e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports